/*
constants.js
项目的所有常量
 */

// 域名，正式的那种: https://point5.cn/
export const DefaultURL = 'https://point5.cn/'
// export const DefaultURL = 'http://127.0.0.1:8001/'
// 测试的那种域名
export const TestLocalURL = 'https://127.0.0.1:8000/'


// 本地存储的indexedDB
// 数据库名称
export const INDEXED_DB_NAME = 'point5'
// 数据库版本
// 版本用于标识数据库的结构，当有新的结构或者字段时，数字加1，即进行更新
export const INDEXED_DB_VERSION = 4
// 双增公式在indexedDB中的字段名称
export const INDEXED_DB_DOUBLE_INC_KEY = 'doubleFML'


// 存储在sessionStorage会话存储中的，当前激活的会话id的key
export const ACTIVE_SESSION_KEY = 'activeSession';
// 当前激活的会话id默认值
export const ACTIVE_SESSION_DEFAULT_VALUE = '--';


// 用户的ID
export const USER_KEY = 'user';
// 默认的user用户ID
export const USER_DEFAULT_VALUE = 'point5';


// 建议问题
export const SUGGESTION_DEFAULT_VALUE_1 = '什么是舒效比？';
export const SUGGESTION_DEFAULT_VALUE_2 = '双增公式有什么意义？';
export const SUGGESTION_DEFAULT_VALUE_3 = '温度胶囊是如何发现管道泄露的？';

// 点五的三种系统的角色
// system, user, assistant
export const POINT5_USER = 'user';
export const POINT5_SYSTEM = 'system';
export const POINT5_ASSISTANT = 'assistant';